import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Action, State, StateContext } from '@ngxs/store';
import { dispatchRequest } from '../dispatch-request';

import {
  GetCostCentresAction,
  GetCostCentresSuccessAction,
  GetCostCentresFailAction,
} from './cost-centre.actions';
import { updateEntities } from '../utils';
import { CostCentre } from '../../core/models/cost-centre.model';

export interface CostCentreStateModel {
  entities: { [key: number]: CostCentre };
  ids: number[];
}

@State<CostCentreStateModel>({
  name: 'costCentre',
  defaults: {
    entities: {},
    ids: [],
  },
})
@Injectable()
export class CostCentreState {

  constructor(
    private httpClient: HttpClient,
  ) {
  }

  @Action(GetCostCentresAction)
  getCostCentres(
    ctx: StateContext<CostCentreStateModel>,
  ) {
    const request = this.httpClient.get('GetCostCentres');

    return dispatchRequest(
      request,
      ctx,
      GetCostCentresSuccessAction,
      GetCostCentresFailAction,
    );
  }

  @Action(GetCostCentresSuccessAction)
  getCostCentresSuccess(
    ctx: StateContext<CostCentreStateModel>,
    action: GetCostCentresSuccessAction,
  ) {
    const stateUpdate = updateEntities(action.payload, CostCentre, 'costCentreId');
    ctx.patchState(stateUpdate);
  }
}
